var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconStairsPersonDescend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 3.56,
    r: 2.63,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.55 11.15c-2.45 0-2.55-3.09-7.8-3.09a6 6 0 0 0-6 6 1.5 1.5 0 1 0 3 0A3 3 0 0 1 6 11.15a16.41 16.41 0 0 1-2.75 9.58 1.5 1.5 0 1 0 2.5 1.66A19.27 19.27 0 0 0 8 17.93l2.21 1.19 1.2 2.25a1.51 1.51 0 0 0 2 .83 1.5 1.5 0 0 0 .83-1.95c-2.37-4.45-1-2.74-5.45-5.23a16.76 16.76 0 0 0 .21-3.4c3.12 1.68 3.29 2.53 5.55 2.53a1.5 1.5 0 0 0 0-3Zm8.7 5.91h-3v3h-3v3h-1.5",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconStairsPersonDescend);
export default __webpack_public_path__ + "static/media/streamline-icon-stairs-person-descend.1045793b.svg";
export { ForwardRef as ReactComponent };